import { Encoder, LogEntry } from './types'

export class StandardEncoder implements Encoder {
  encode(entry: LogEntry): string {
    const { timestamp, level, namespace, message, userId, ...rest } = entry
    const contextString = Object.entries(rest)
      .map(([key, value]) => `${key}=${value}`)
      .join(', ')
    return `${timestamp} ${level.toUpperCase().padEnd(5)} :${userId ?? ''}: [${namespace}] - ${message} ${contextString}`
  }
}
